import { IS_SECURE, COOKIE_DOMAIN } from '@/environment';

// 4096 Characters is the max size for a single cookie. Most browsers will allow you to
// store more per domain, but it can vary greatly by vendor.
const MAX_COOKIE_BYTES = 4096;

interface OptionsType {
  expires?: number;
  secure?: boolean;
  domain?: string;
}

interface CookieValidationResponse {
  ok: boolean;
  message?: string;
}

const DEFAULT_OPTIONS = (): OptionsType => {
  const defaultOptions: OptionsType = {
    expires: 90,
    secure: IS_SECURE(),
  };
  const domain = COOKIE_DOMAIN();

  return !domain ? defaultOptions : { domain, ...defaultOptions };
};

const stringByteSize = (string: string) =>
  encodeURI(string).split(/%(?:u[0-9A-F]{2})?[0-9A-F]{2}|./).length - 1;

const cookieExceedsMaxSize = (key: string, value: string | string[]): boolean =>
  stringByteSize(`${key}=${value}`) > MAX_COOKIE_BYTES;

export const validateCookie = (
  key: string,
  value: string | string[],
): CookieValidationResponse => {
  return cookieExceedsMaxSize(key, value)
    ? {
        ok: false,
        message: 'Cookie exceeds maximum size',
      }
    : { ok: true };
};

export const getCookieOptions = <T extends Record<string, any>>(
  options: T = {} as T,
): T & OptionsType => ({ ...DEFAULT_OPTIONS(), ...options });
